import React from 'react'
import { Modal } from "antd"
import { Button } from "components"

interface ModalAlertProps {
  open: boolean
  onAccept: () => void
  onCancel: () => void
  title: string
  texts: {
    accept: string
  }
  description: string
}

const ModalAlert = ({open, onAccept, onCancel, title, texts, description }: ModalAlertProps) => {
  return (
    <Modal
      title={title}
      open={open}
      footer={false}
      onCancel={() => onCancel()}
      centered
    >
      <p>{description}</p>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
        <Button type_button="primary"  font_size={14} paddingVertical={3} paddingHorizontal={8} height={32} width="fit-content" title={texts.accept} onClick={() => onAccept()} />
      </div>
    </Modal>
  )
}

export default ModalAlert